@if (isOpen()) {
  <div
    class="modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div
      class="bg-white rounded-lg w-full h-full overflow-hidden shadow-2xl flex flex-col"
    >
      <!-- Header -->
      <div
        class="sticky top-0 bg-brand-tertiary text-white px-6 py-4 flex justify-between items-center z-10"
      >
        <div>
          <h3 class="text-xl font-bold m-0">{{ modalTitle }}</h3>
          <p class="text-sm opacity-90 m-0">
            LG Afecto:
            <span class="font-bold text-yellow-300">{{ lgBase }}</span>
            @if (placerOrderNumber) {
              <span class="ml-4"
                >Orden:
                <span class="font-bold text-yellow-300">{{
                  placerOrderNumber
                }}</span></span
              >
            }
          </p>
        </div>
        <button
          type="button"
          (click)="close()"
          class="text-white hover:text-gray-200 text-2xl font-bold"
          aria-label="Cerrar modal"
        >
          ×
        </button>
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto p-6">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <!-- Formulario del Padre -->
          <div
            class="border-2 rounded-lg p-4 relative"
            [class.border-green-500]="isFatherValid()"
            [class.border-gray-300]="!isFatherValid()"
            [class.opacity-40]="isFatherLocked"
          >
            @if (isFatherLocked) {
              <div class="absolute inset-0 bg-gray-100 bg-opacity-60 z-10 flex flex-col items-center justify-center rounded-lg">
                <p class="text-gray-600 font-semibold text-center px-4">🔒 Ya ingresó datos en la sección de la {{ examType === 'FUTUROS_PADRES' ? 'Futura Madre' : 'Madre' }}.</p>
                <p class="text-gray-500 text-sm text-center px-4">Solo puede ingresar uno de los dos para {{ examType === 'FUTUROS_PADRES' ? 'Futuros Padres' : 'DUO' }}.</p>
                <button type="button" (click)="clearForm(motherForm, 'F')" class="mt-2 px-4 py-1.5 bg-brand-tertiary text-white text-sm rounded-md hover:bg-brand-tertiary/90">Limpiar {{ examType === 'FUTUROS_PADRES' ? 'Futura Madre' : 'Madre' }} y usar este</button>
              </div>
            }
            <div class="flex justify-between items-center mb-4">
              <div>
                <h4 class="text-lg font-bold text-brand-tertiary m-0">
                  {{ fatherSectionTitle }}
                </h4>
                <p class="text-sm text-amber-600 m-0">LG: {{ lgPadre }}</p>
              </div>
              @if (isFatherValid()) {
                <span class="text-green-600 text-2xl">✓</span>
              } @else {
                <span class="text-gray-400 text-2xl">○</span>
              }
            </div>

            <form [formGroup]="fatherForm" class="space-y-3">
              <!-- Identificación -->
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Tipo ID *</label
                  >
                  <select
                    formControlName="identifierTypeCode"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-tertiary"
                  >
                    <option value="">Seleccione</option>
                    @for (item of identifierTypes; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Número Documento *</label
                  >
                  <input
                    type="text"
                    formControlName="idNumber"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Ingrese número"
                  />
                </div>
              </div>

              <!-- Nombres completos -->
              <div class="grid grid-cols-4 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Nombres *</label
                  >
                  <input
                    type="text"
                    formControlName="givenName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Nombres"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Segundo Nombre</label
                  >
                  <input
                    type="text"
                    formControlName="middleName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Segundo nombre"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Primer Apellido *</label
                  >
                  <input
                    type="text"
                    formControlName="familyName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Primer apellido"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Segundo Apellido</label
                  >
                  <input
                    type="text"
                    formControlName="maternalFamilyName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Segundo apellido"
                  />
                </div>
              </div>

              <!-- Datos personales -->
              <div class="grid grid-cols-3 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Sexo *</label
                  >
                  <select
                    formControlName="administrativeSex"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Fecha Nacimiento *</label
                  >
                  <input
                    type="date"
                    [max]="getMaxDate()" min="1900-01-01" formControlName="birthDate"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Estado Civil</label
                  >
                  <input
                    type="text"
                    formControlName="maritalStatus"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Ingrese estado civil"
                  />
                </div>
              </div>

              <!-- Observaciones del Paciente -->
              <div class="mt-2">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Observación de datos del paciente (opcional)</label
                >
                <textarea
                  formControlName="userDataDescription"
                  rows="2"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                  placeholder="Observación de datos del paciente"
                ></textarea>
              </div>

              <!-- Contacto -->
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Teléfono *</label
                  >
                  <input
                    type="tel"
                    formControlName="telephoneNumber"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Teléfono (7-10 dígitos)"
                  />
                  @if (hasFieldError(fatherForm, 'telephoneNumber', 'required')) {
                    <span class="text-red-500 text-xs">Este campo es requerido</span>
                  }
                  @if (hasFieldError(fatherForm, 'telephoneNumber', 'phoneInvalid')) {
                    <span class="text-red-500 text-xs">Ingrese un número válido (7-10 dígitos)</span>
                  }
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Correo Electrónico</label
                  >
                  <input
                    type="email"
                    formControlName="emailAddress"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="correo@ejemplo.com"
                  />
                  @if (hasFieldError(fatherForm, 'emailAddress', 'email')) {
                    <span class="text-red-500 text-xs">Correo electrónico inválido</span>
                  }
                </div>
              </div>

              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Dirección (opcional)</label
                >
                <input
                  type="text"
                  formControlName="streetAddress"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  placeholder="Dirección"
                />
              </div>

              <!-- Datos de Orden (heredados del afecto, ocultos) -->

              <!-- Datos de Muestra -->
              <h5
                class="text-sm font-semibold text-brand-tertiary mt-3 mb-2 border-t pt-2"
              >
                Datos de Muestra
              </h5>
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Código de muestra *</label
                  >
                  <input
                    type="text"
                    formControlName="caseNumber"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Código de muestra"
                  />
                </div>
              </div>
              <div class="grid grid-cols-2 gap-2 mt-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Tipo Muestra *</label
                  >
                  <select
                    formControlName="specimenTypeId"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="">Seleccione</option>
                    @for (item of specimenTypes; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Contenedor *</label
                  >
                  <select
                    formControlName="specimenContainerId"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="">Seleccione</option>
                    @for (item of specimenContainers; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="mt-2">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Observación de datos de muestra (opcional)</label
                >
                <textarea
                  formControlName="descriptionDataSample"
                  rows="2"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                  placeholder="Observación de datos de muestra"
                ></textarea>
              </div>
              <div class="mt-2">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="consentForUseOfSamples"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >Consentimiento de uso de la información de muestra</span
                  >
                </label>
              </div>

              <!-- Datos del Examen -->
              <h5
                class="text-sm font-semibold text-brand-tertiary mt-3 mb-2 border-t pt-2"
              >
                Datos del Examen
              </h5>
              <div class="grid grid-cols-1 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Examen solicitado *</label
                  >
                  <select
                    formControlName="examTypeSelected"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="">Seleccione</option>
                    @for (item of examTypes; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="flex gap-4 mt-2">
                <label class="flex items-center gap-1 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="acmg"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >¿Debe realizar ACMG?</span
                  >
                </label>
                <label class="flex items-center gap-1 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="mlpa"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >¿Debe realizar MLPA?</span
                  >
                </label>
                <label class="flex items-center gap-1 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="prioritization"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >Requiere priorización</span
                  >
                </label>
              </div>
              <div class="mt-2">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Observación de datos del examen (opcional)</label
                >
                <textarea
                  formControlName="descriptionDataExam"
                  rows="2"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                  placeholder="Observación de datos del examen"
                ></textarea>
              </div>

              <!-- Datos de Reproceso -->
              <h5
                class="text-sm font-semibold text-brand-tertiary mt-3 mb-2 border-t pt-2"
              >
                Datos de Reproceso
              </h5>
              <div class="mt-2">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="isReprocess"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700">¿Es reproceso?</span>
                </label>
              </div>
              @if (isFatherReprocessChecked()) {
                <div
                  class="grid grid-cols-2 gap-2 mt-2 p-2 bg-gray-50 rounded-lg"
                >
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1"
                      >Causa de Reproceso</label
                    >
                    <select
                      formControlName="causeReprocessId"
                      class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    >
                      <option value="">Seleccione</option>
                      @for (item of causeReprocessOptions; track item.value) {
                        <option [value]="item.value">{{ item.label }}</option>
                      }
                    </select>
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1"
                      >Estado de Reproceso</label
                    >
                    <select
                      formControlName="statusReprocessId"
                      class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    >
                      <option value="">Seleccione</option>
                      @for (item of statusReprocessOptions; track item.value) {
                        <option [value]="item.value">{{ item.label }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="mt-2">
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Observación de Reproceso</label
                  >
                  <textarea
                    formControlName="reprocessDescription"
                    rows="2"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                    placeholder="Observación de reproceso"
                  ></textarea>
                </div>
              }
            </form>
          </div>

          <!-- Formulario de la Madre -->
          <div
            class="border-2 rounded-lg p-4 relative"
            [class.border-green-500]="isMotherValid()"
            [class.border-gray-300]="!isMotherValid()"
            [class.opacity-40]="isMotherLocked"
          >
            @if (isMotherLocked) {
              <div class="absolute inset-0 bg-gray-100 bg-opacity-60 z-10 flex flex-col items-center justify-center rounded-lg">
                <p class="text-gray-600 font-semibold text-center px-4">🔒 Ya ingresó datos en la sección del {{ examType === 'FUTUROS_PADRES' ? 'Futuro Padre' : 'Padre' }}.</p>
                <p class="text-gray-500 text-sm text-center px-4">Solo puede ingresar uno de los dos para {{ examType === 'FUTUROS_PADRES' ? 'Futuros Padres' : 'DUO' }}.</p>
                <button type="button" (click)="clearForm(fatherForm, 'M')" class="mt-2 px-4 py-1.5 bg-brand-tertiary text-white text-sm rounded-md hover:bg-brand-tertiary/90">Limpiar {{ examType === 'FUTUROS_PADRES' ? 'Futuro Padre' : 'Padre' }} y usar este</button>
              </div>
            }
            <div class="flex justify-between items-start mb-4">
              <div>
                <h4 class="text-lg font-bold text-brand-tertiary m-0">
                  {{ motherSectionTitle }}
                </h4>
                <p class="text-sm text-amber-600 m-0">LG: {{ lgMadre }}</p>
              </div>
              <div class="flex flex-col items-end gap-1">
                <button
                  type="button"
                  (click)="copyFromFatherToMother()"
                  class="text-lg text-blue-600 hover:text-blue-800 cursor-pointer p-1 rounded hover:bg-blue-50 transition-colors"
                  [disabled]="!isFatherValid()"
                  [class.opacity-50]="!isFatherValid()"
                  [class.cursor-not-allowed]="!isFatherValid()"
                  title="Copiar"
                >
                  📋
                </button>
                @if (isMotherValid()) {
                  <span class="text-green-600 text-2xl">✓</span>
                } @else {
                  <span class="text-gray-400 text-2xl">○</span>
                }
              </div>
            </div>

            <form [formGroup]="motherForm" class="space-y-3">
              <!-- Identificación -->
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Tipo ID *</label
                  >
                  <select
                    formControlName="identifierTypeCode"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="">Seleccione</option>
                    @for (item of identifierTypes; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Número Documento *</label
                  >
                  <input
                    type="text"
                    formControlName="idNumber"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Ingrese número"
                  />
                </div>
              </div>

              <!-- Nombres completos -->
              <div class="grid grid-cols-4 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Nombres *</label
                  >
                  <input
                    type="text"
                    formControlName="givenName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Nombres"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Segundo Nombre</label
                  >
                  <input
                    type="text"
                    formControlName="middleName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Segundo nombre"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Primer Apellido *</label
                  >
                  <input
                    type="text"
                    formControlName="familyName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Primer apellido"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Segundo Apellido</label
                  >
                  <input
                    type="text"
                    formControlName="maternalFamilyName"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Segundo apellido"
                  />
                </div>
              </div>

              <!-- Datos personales -->
              <div class="grid grid-cols-3 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Sexo *</label
                  >
                  <select
                    formControlName="administrativeSex"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Fecha Nacimiento *</label
                  >
                  <input
                    type="date"
                    [max]="getMaxDate()" min="1900-01-01" formControlName="birthDate"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Estado Civil</label
                  >
                  <input
                    type="text"
                    formControlName="maritalStatus"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Ingrese estado civil"
                  />
                </div>
              </div>

              <!-- Observaciones del Paciente -->
              <div class="mt-2">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Observación de datos del paciente (opcional)</label
                >
                <textarea
                  formControlName="userDataDescription"
                  rows="2"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                  placeholder="Observación de datos del paciente"
                ></textarea>
              </div>

              <!-- Contacto -->
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Teléfono *</label
                  >
                  <input
                    type="tel"
                    formControlName="telephoneNumber"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Teléfono (7-10 dígitos)"
                  />
                  @if (hasFieldError(motherForm, 'telephoneNumber', 'required')) {
                    <span class="text-red-500 text-xs">Este campo es requerido</span>
                  }
                  @if (hasFieldError(motherForm, 'telephoneNumber', 'phoneInvalid')) {
                    <span class="text-red-500 text-xs">Ingrese un número válido (7-10 dígitos)</span>
                  }
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Correo Electrónico</label
                  >
                  <input
                    type="email"
                    formControlName="emailAddress"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="correo@ejemplo.com"
                  />
                  @if (hasFieldError(motherForm, 'emailAddress', 'email')) {
                    <span class="text-red-500 text-xs">Correo electrónico inválido</span>
                  }
                </div>
              </div>

              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Dirección (opcional)</label
                >
                <input
                  type="text"
                  formControlName="streetAddress"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  placeholder="Dirección"
                />
              </div>

              <!-- Datos de Orden (heredados del afecto, ocultos) -->

              <!-- Datos de Muestra -->
              <h5
                class="text-sm font-semibold text-brand-tertiary mt-3 mb-2 border-t pt-2"
              >
                Datos de Muestra
              </h5>
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Código de muestra *</label
                  >
                  <input
                    type="text"
                    formControlName="caseNumber"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    placeholder="Código de muestra"
                  />
                </div>
              </div>
              <div class="grid grid-cols-2 gap-2 mt-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Tipo Muestra *</label
                  >
                  <select
                    formControlName="specimenTypeId"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="">Seleccione</option>
                    @for (item of specimenTypes; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Contenedor *</label
                  >
                  <select
                    formControlName="specimenContainerId"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="">Seleccione</option>
                    @for (item of specimenContainers; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="mt-2">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Observación de datos de muestra (opcional)</label
                >
                <textarea
                  formControlName="descriptionDataSample"
                  rows="2"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                  placeholder="Observación de datos de muestra"
                ></textarea>
              </div>
              <div class="mt-2">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="consentForUseOfSamples"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >Consentimiento de uso de la información de muestra</span
                  >
                </label>
              </div>

              <!-- Datos del Examen -->
              <h5
                class="text-sm font-semibold text-brand-tertiary mt-3 mb-2 border-t pt-2"
              >
                Datos del Examen
              </h5>
              <div class="grid grid-cols-1 gap-2">
                <div>
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Examen solicitado *</label
                  >
                  <select
                    formControlName="examTypeSelected"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                  >
                    <option value="">Seleccione</option>
                    @for (item of examTypes; track item.value) {
                      <option [value]="item.value">{{ item.label }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="flex gap-4 mt-2">
                <label class="flex items-center gap-1 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="acmg"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >¿Debe realizar ACMG?</span
                  >
                </label>
                <label class="flex items-center gap-1 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="mlpa"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >¿Debe realizar MLPA?</span
                  >
                </label>
                <label class="flex items-center gap-1 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="prioritization"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700"
                    >Requiere priorización</span
                  >
                </label>
              </div>
              <div class="mt-2">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Observación de datos del examen (opcional)</label
                >
                <textarea
                  formControlName="descriptionDataExam"
                  rows="2"
                  class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                  placeholder="Observación de datos del examen"
                ></textarea>
              </div>

              <!-- Datos de Reproceso -->
              <h5
                class="text-sm font-semibold text-brand-tertiary mt-3 mb-2 border-t pt-2"
              >
                Datos de Reproceso
              </h5>
              <div class="mt-2">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="isReprocess"
                    class="w-4 h-4"
                  />
                  <span class="text-xs text-gray-700">¿Es reproceso?</span>
                </label>
              </div>
              @if (isMotherReprocessChecked()) {
                <div
                  class="grid grid-cols-2 gap-2 mt-2 p-2 bg-gray-50 rounded-lg"
                >
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1"
                      >Causa de Reproceso</label
                    >
                    <select
                      formControlName="causeReprocessId"
                      class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    >
                      <option value="">Seleccione</option>
                      @for (item of causeReprocessOptions; track item.value) {
                        <option [value]="item.value">{{ item.label }}</option>
                      }
                    </select>
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1"
                      >Estado de Reproceso</label
                    >
                    <select
                      formControlName="statusReprocessId"
                      class="w-full p-1.5 text-sm border border-gray-300 rounded-md"
                    >
                      <option value="">Seleccione</option>
                      @for (item of statusReprocessOptions; track item.value) {
                        <option [value]="item.value">{{ item.label }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="mt-2">
                  <label class="block text-xs font-medium text-gray-700 mb-1"
                    >Observación de Reproceso</label
                  >
                  <textarea
                    formControlName="reprocessDescription"
                    rows="2"
                    class="w-full p-1.5 text-sm border border-gray-300 rounded-md resize-none"
                    placeholder="Observación de reproceso"
                  ></textarea>
                </div>
              }
            </form>
          </div>
        </div>

        <!-- Mensaje de validación -->
        <div
          class="mt-4 p-3 rounded-lg"
          [class.bg-amber-50]="!canSave()"
          [class.bg-green-50]="canSave()"
        >
          @if (examType === 'TRIO') {
            @if (!canSave()) {
              <p class="text-amber-700 m-0">
                ⚠️ Para TRIO debe completar los datos del Padre
                <strong>Y</strong> la Madre
              </p>
            } @else {
              <p class="text-green-700 m-0">
                ✓ Formularios completos. Puede guardar los familiares.
              </p>
            }
          } @else if (examType === 'DUO') {
            @if (!canSave()) {
              <p class="text-amber-700 m-0">
                ⚠️ Para DUO debe completar los datos del Padre
                <strong>O</strong> la Madre
              </p>
            } @else {
              <p class="text-green-700 m-0">
                ✓ Formulario completo. Puede guardar el familiar.
              </p>
            }
          } @else if (examType === 'FUTUROS_PADRES') {
            @if (!canSave()) {
              <p class="text-amber-700 m-0">
                ⚠️ Para Futuros Padres debe completar los datos de la
                <strong>pareja</strong>
              </p>
            } @else {
              <p class="text-green-700 m-0">
                ✓ Formulario completo. Puede guardar la pareja.
              </p>
            }
          }
        </div>
      </div>

      <!-- Footer -->
      <div
        class="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex justify-end gap-4 z-10"
      >
        <button
          type="button"
          (click)="close()"
          class="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="saveFamilyMembers()"
          [disabled]="!canSave() || isLoading()"
          class="px-6 py-2 bg-brand-tertiary text-white rounded-md hover:bg-brand-tertiary/90 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          @if (isLoading()) {
            Guardando...
          } @else {
            Guardar Familiares
          }
        </button>
      </div>
    </div>
  </div>
}


